import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {
  CAlert,
  CBadge,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CCollapse,
  CFormCheck,
  CRow,
  CSpinner,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react';

export default class OmieTabelaPrecosExecList extends Component {
  static propTypes = {
    location: PropTypes.object,
  };

  timer = null;

  constructor(props) {
    super(props);

    const routeState = props.location?.state || {};

    this.state = {
      loading: false,
      error: '',
      data: [],
      cd_estabelecimento: routeState.cd_estabelecimento ?? '',
      nome_filial: routeState.nome_filial ?? '',
      autoRefresh: true,
      openedRows: {},
      detalhesExecucao: {},
    };
  }

  componentDidMount() {
    this.load();
    this.startPolling();
  }

    carregarDetalhe = async (item) => {
    const rowKey = item.id || item.arquivo_log || item.logFile;

    if (!item?.arquivo_log && !item?.logFile) return;

    try {
      const logFile = item?.arquivo_log || item?.logFile;

      const response = await axios.get(
        'https://integradorbaoba.masterdaweb.net/api/tabelapreco/getDetalheCTRLTabelaPrecos',
        {
          params: { logFile },
        }
      );

      this.setState((prev) => ({
        detalhesExecucao: {
          ...prev.detalhesExecucao,
          [rowKey]: response.data || {},
        },
      }));
    } catch (error) {
      this.setState((prev) => ({
        detalhesExecucao: {
          ...prev.detalhesExecucao,
          [rowKey]: {
            error:
              error?.response?.data?.error ||
              error?.message ||
              'Erro ao carregar detalhe da execução.',
          },
        },
      }));
    }
  };

  componentWillUnmount() {
    this.stopPolling();
  }

  startPolling = () => {
    this.stopPolling();
    this.timer = setInterval(() => {
      if (this.state.autoRefresh) {
        this.load(false);
      }
    }, 10000);
  };

  stopPolling = () => {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  };

  togglePolling = () => {
    this.setState((prev) => ({
      autoRefresh: !prev.autoRefresh,
    }));
  };

    toggleRow = async (key, item) => {
    const isOpening = !this.state.openedRows[key];

    this.setState((prev) => ({
      openedRows: {
        ...prev.openedRows,
        [key]: isOpening,
      },
    }));

    if (isOpening) {
      const detalheAtual = this.state.detalhesExecucao[key];
      if (!detalheAtual) {
        await this.carregarDetalhe(item);
      }
    }
  };

  formatDateTime = (value) => {
    if (!value) return '-';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return d.toLocaleString('pt-BR');
  };

  renderStatus(status) {
    const s = (status || '').toLowerCase();

    if (s.includes('erro')) return <CBadge color="danger">{status}</CBadge>;
    if (s.includes('processando') || s.includes('andamento') || s.includes('iniciada')) {
      return <CBadge color="warning">{status}</CBadge>;
    }
    if (s.includes('concluido_com_erros')) return <CBadge color="warning">{status}</CBadge>;
    if (s.includes('concluido') || s.includes('sucesso') || s.includes('finalizada')) {
      return <CBadge color="success">{status}</CBadge>;
    }

    return <CBadge color="secondary">{status || 'N/D'}</CBadge>;
  }

  load = async (showLoader = true) => {
    const { cd_estabelecimento } = this.state;

    if (showLoader) {
      this.setState({ loading: true, error: '' });
    } else {
      this.setState({ error: '' });
    }

    try {
      const res = await axios.get(
        'https://integradorbaoba.masterdaweb.net/api/tabelapreco/getCTRLTabelaPrecos',
        {
          params: { cd_estabelecimento },
        }
      );

      this.setState({
        data: Array.isArray(res.data) ? res.data : [],
      });
    } catch (error) {
      const backendError =
        error?.response?.data?.error ||
        error?.message ||
        'Erro ao consultar execuções.';

      this.setState({ error: backendError });
    } finally {
      if (showLoader) {
        this.setState({ loading: false });
      }
    }
  };

  render() {
    const {
      loading,
      error,
      data,
      nome_filial,
      cd_estabelecimento,
      autoRefresh,
      openedRows,
      detalhesExecucao,
    } = this.state;

    return (
      <CRow>
        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader>
              <strong>Consulta de Execuções - Tabelas de Preço OMIE</strong>
            </CCardHeader>

            <CCardBody>
              <CRow className="align-items-center">
                <CCol md={6}>
                  <div>
                    <strong>Filial:</strong> {nome_filial || 'Todas'}
                    {cd_estabelecimento !== '' ? ` (${cd_estabelecimento})` : ''}
                  </div>
                </CCol>

                <CCol md={3}>
                  <CFormCheck
                    id="autoRefreshExecTabelaPreco"
                    label="Atualização automática"
                    checked={autoRefresh}
                    onChange={this.togglePolling}
                  />
                </CCol>

                <CCol md={3}>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <CButton color="primary" onClick={() => this.load(true)} disabled={loading}>
                      {loading ? (
                        <>
                          <CSpinner size="sm" className="me-2" />
                          Atualizando...
                        </>
                      ) : (
                        'Atualizar agora'
                      )}
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>

        {error ? (
          <CCol xs={12}>
            <CAlert color="danger">{error}</CAlert>
          </CCol>
        ) : null}

        <CCol xs={12}>
          <CCard>
            <CCardHeader>
              <strong>Execuções Encontradas</strong>
            </CCardHeader>

            <CCardBody>
              <CTable hover responsive align="middle">
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell style={{ minWidth: 120 }}>Detalhe</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: 180 }}>Início</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: 180 }}>Fim</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: 260 }}>Tabela</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: 120 }}>Ação</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: 120 }}>Status</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: 100 }}>Itens</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: 100 }}>Sucesso</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: 100 }}>Erros</CTableHeaderCell>
                    <CTableHeaderCell style={{ minWidth: 140 }}>Código OMIE</CTableHeaderCell>
                 
                  </CTableRow>
                </CTableHead>

                <CTableBody>
                  {loading && data.length === 0 ? (
                    <CTableRow>
                      <CTableDataCell colSpan={11} className="text-center">
                        <CSpinner />
                      </CTableDataCell>
                    </CTableRow>
                  ) : data.length === 0 ? (
                    <CTableRow>
                      <CTableDataCell colSpan={11}>
                        Nenhuma execução encontrada.
                      </CTableDataCell>
                    </CTableRow>
                  ) : (
                    data.map((item, idx) => {
                      const rowKey = item.id || idx;
                      const isOpen = !!openedRows[rowKey];
                      const detalhe = detalhesExecucao[rowKey] || {};
                      const linhas = Array.isArray(detalhe?.linhas) ? detalhe.linhas : [];
                      const resumo = detalhe?.resumo || {};
                      const detalheError = detalhe?.error || '';
                      const linhasErro = linhas.filter(
                        (l) =>
                          String(l?.level || '').toUpperCase() === 'ERROR' ||
                          String(l?.message || '').toLowerCase().includes('falha') ||
                          String(l?.message || '').toLowerCase().includes('erro')
                      );
                      return (
                        <React.Fragment key={rowKey}>
                          <CTableRow>
                             <CTableDataCell>
                              <CButton
                                size="sm"
                                color={isOpen ? 'secondary' : 'info'}
                                variant="outline"
                                onClick={() => this.toggleRow(rowKey, item)}
                              >
                                {isOpen ? 'Ocultar' : 'Ver mais'}
                              </CButton>
                            </CTableDataCell>
                            <CTableDataCell>{this.formatDateTime(item.data_inicio)}</CTableDataCell>
                            <CTableDataCell>{this.formatDateTime(item.data_fim)}</CTableDataCell>
                            <CTableDataCell>{item.tabela || '-'}</CTableDataCell>
                            <CTableDataCell>{item.acao || '-'}</CTableDataCell>
                            <CTableDataCell>{this.renderStatus(item.status)}</CTableDataCell>
                            <CTableDataCell>{item.totalItens ?? 0}</CTableDataCell>
                            <CTableDataCell>{item.sucesso ?? 0}</CTableDataCell>
                            <CTableDataCell>{item.erros ?? 0}</CTableDataCell>
                            <CTableDataCell>{item.nCodTabPreco || '-'}</CTableDataCell>
                           
                          </CTableRow>

                          <CTableRow>
                            <CTableDataCell colSpan={11} style={{ padding: 0, border: 0 }}>
                              <CCollapse visible={isOpen}>
                                <div style={{ padding: 16, background: '#f8f9fa' }}>
                                  <CRow className="mb-3">
                                    <CCol md={6}>
                                      <div className="mb-2">
                                        <strong>Processo:</strong> {item.processo || '-'}
                                      </div>
                                      <div className="mb-2">
                                        <strong>Arquivo de Log:</strong> {item.arquivo_log || '-'}
                                      </div>
                                      <div className="mb-2">
                                        <strong>Log File:</strong> {item.logFile || '-'}
                                      </div>
                                    </CCol>

                                    <CCol md={6}>
                                      <div className="mb-2">
                                        <strong>Tamanho do Log:</strong> {item.tamanho_bytes || 0} bytes
                                      </div>
                                      <div className="mb-2">
                                        <strong>Última Atualização:</strong> {this.formatDateTime(item.ultima_atualizacao)}
                                      </div>
                                      <div className="mb-2">
                                        <strong>Status:</strong> {item.status || '-'}
                                      </div>
                                    </CCol>
                                  </CRow>

                                  {detalheError ? (
                                    <CAlert color="danger" className="mb-0">
                                      {detalheError}
                                    </CAlert>
                                  ) : (
                                    <>
                                      <CRow className="mb-3">
                                        <CCol md={3}>
                                          <strong>Total Itens</strong><br />
                                          {resumo?.totalItens ?? item?.totalItens ?? 0}
                                        </CCol>
                                        <CCol md={3}>
                                          <strong>Sucesso</strong><br />
                                          {resumo?.sucesso ?? item?.sucesso ?? 0}
                                        </CCol>
                                        <CCol md={3}>
                                          <strong>Erros</strong><br />
                                          {resumo?.erros ?? item?.erros ?? 0}
                                        </CCol>
                                        <CCol md={3}>
                                          <strong>Ação</strong><br />
                                          {resumo?.acao ?? item?.acao ?? '-'}
                                        </CCol>
                                      </CRow>

                                      {linhasErro.length > 0 ? (
                                        <>
                                          <div className="mb-2">
                                            <strong>Detalhe do Erro</strong>
                                          </div>

                                          <div style={{ maxHeight: 350, overflowY: 'auto' }}>
                                            {linhasErro.map((linha, idxErro) => (
                                              <CCard key={idxErro} className="mb-2">
                                                <CCardBody style={{ padding: 12 }}>
                                                  <div><strong>Data/Hora:</strong> {linha?.timestamp || '-'}</div>
                                                  <div><strong>Nível:</strong> {linha?.level || '-'}</div>
                                                  <div><strong>Mensagem:</strong> {linha?.message || '-'}</div>
                                                  {linha?.extra ? (
                                                    <pre style={{ whiteSpace: 'pre-wrap', marginTop: 8, marginBottom: 0 }}>
                                                      {typeof linha.extra === 'string'
                                                        ? linha.extra
                                                        : JSON.stringify(linha.extra, null, 2)}
                                                    </pre>
                                                  ) : null}
                                                </CCardBody>
                                              </CCard>
                                            ))}
                                          </div>
                                        </>
                                      ) : (
                                        <CAlert color="success" className="mb-0">
                                          Nenhum erro detalhado encontrado no log desta execução.
                                        </CAlert>
                                      )}
                                    </>
                                  )}
                                </div>
                              </CCollapse>
                            </CTableDataCell>
                          </CTableRow>
                        </React.Fragment>
                      );
                    })
                  )}
                </CTableBody>
              </CTable>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    );
  }
}